import moment from 'moment';
import R from 'ramda';
import PropTypes from 'prop-types';
import { STATUS, SUBLICENSE_DISPLAY_NAMES, TYPES, CURRENT_MAX_VERSION, MECHANISMS } from '../../server/constants';
import { capitalizeStr, isNilOrEmpty } from '_utils';

export const licenseUpgradePropType = PropTypes.shape({
  _id: PropTypes.string.isRequired
});

export const licensePropType = PropTypes.shape({
  _id: PropTypes.string.isRequired
});

export const isAcademicLicense = (sl) => {
  const fsInfo = sl && sl.activated_info && sl.activated_info.fastspring;
  return fsInfo && fsInfo.surveys && fsInfo.surveys.id_image;
};

export const licenseIsUpgradable = l => (
  l.status === STATUS.ACTIVE &&
  isNilOrEmpty(l.upgraded_license_id) &&
  l.name !== CURRENT_MAX_VERSION &&
  l.type === TYPES.FULL &&
  R.contains(
    R.path(['activated_info', 'mechanism'], l),
    [MECHANISMS.FASTSPRING, MECHANISMS.RESELLER_AC, MECHANISMS.SERIAL_UPGRADE, MECHANISMS.USER]
  )
);

// Sublicenses
export const sublicensePropType = PropTypes.shape({
  _id: PropTypes.string.isRequired
});

// Shows active sublicenses for a license at a glance.
export const getShortSublicensesLabelWithExpiry = sublicenses => {
  if (!sublicenses.length) return '';

  const summary = sublicenses
    .filter((sl) => sl.status === STATUS.ACTIVE)
    .map((sl) => {
      let text = `${SUBLICENSE_DISPLAY_NAMES[sl.name]} ${capitalizeStr(sl.type)}`;

      if (isAcademicLicense(sl)) {
        text += " Academic";
      }

      if (sl.type !== TYPES.FULL) {
        text += ` exp. ${moment(sl.expires_on).format("YYYY-MM-DD")}`;
      }
      return text;
    })
    .join("; ");

  return summary.length ? `: ${summary}` : "";
};

export const getShortSublicensesLabel = sublicenses => {
  // Display quick summary of addons licenses, no expiry like above
  if (!sublicenses.length) return '';

  const summary = sublicenses
    .filter((sl) => sl.status === STATUS.ACTIVE)
    .map((sl) => `${SUBLICENSE_DISPLAY_NAMES[sl.name]} ${sl.type}`)
    .join('; ');

  return summary || '';
};

export const getLicensePoolLabel = license => {
  if (!license.license_pool) return '';
  return `${license.license_pool.name} - ${license.license_pool.type}`;
};



// WEBPACK FOOTER //
// ./webAdmin/utils/licenses.js